<template>

    <div></div>


</template>
<script>
export default {
    data: function () {return {        
            
    }},    
    components:{},    
    mounted(){
        //   
    },
    

    methods: {

    },
}
</script>


<style scoped>

.menu{
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background: none;
    margin-bottom: 0px;
    padding: 30px 3vw 0px;
    /* border-bottom: 0.5px solid var(--g1); */
    z-index: 100;
    /* background: var(--back); */
    /* background: rgba(255, 255, 255, 0.00001);
    -webkit-backdrop-filter: saturate(180%) blur(40px);
    backdrop-filter: saturate(180%) blur(40px); */
    z-index: 1000;
    font-family: var(--titlefonts);
    width: 100vw;
    background: none;
}

.item{
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 14px;
    letter-spacing: 0.0em;
    /* text-transform: capitalize; */
    color: var(--text);
    margin: 0 10px;
    cursor: pointer;
}
.adminitem{
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    letter-spacing: 0.0em;
    /* text-transform: capitalize; */
    color: white;
    padding: 4px 14px 4px 14px;
    cursor: pointer;
    /* border-radius: 100px; */
}

.adminitem:hover{
    /* background: var(--g05); */
    color: rgba(255, 255, 255, 0.61);
}

.brandtext{
    font-style: normal;
    font-weight: 700;
    margin-left: 15px;
}
.item:hover{
    opacity: .6;
}
.item.router-link-exact-active{
    color: var(--g2);
}
.avatar{
    width: 28px;
    height: 28px;
    border-radius: 100px;
}
</style>

